function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var PersonalFilled = function PersonalFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M12.116 12.427c2.232 0 4.287.425 6.107 1.262 3.135 1.44 4.658 3.632 4.658 6.7 0 1.405-1.192 2.548-2.658 2.548H3.659C2.193 22.937 1 21.794 1 20.39c0-3.124 1.48-5.325 4.528-6.729 1.773-.818 3.805-1.233 6.038-1.233zM11.942 1a5.077 5.077 0 0 1 5.07 5.071 5.08 5.08 0 0 1-5.07 5.072A5.08 5.08 0 0 1 6.87 6.071 5.077 5.077 0 0 1 11.94 1",
    clipRule: "evenodd"
  }));
};
export default PersonalFilled;